import React, { useState } from "react"
import { Grid } from "@mui/material"
import CustomButton from "../../components/custom-button/custom-button.component"
import DownloadAppDialog from "../../components/download-app-dialog/download-app-dialog.component"

import * as S from "./our-mission.styles"

const OurMission = ({
  title,
  description,
  leftButton,
  rightButton,
  image,
  notificationInfo,
}) => {
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <Grid container alignItems="center" spacing={5}>
          <Grid item xs={12} md={6}>
            <S.Title>{title}</S.Title>
            <S.Description>{description}</S.Description>
            <S.ButtonsContainer>
              <CustomButton
                onClick={handleClickOpen}
                className="linearGradient"
                style={{ height: "52px" }}
              >
                {leftButton?.title}
              </CustomButton>
              <CustomButton
                href={rightButton?.url}
                className="lightBorder"
                style={{ height: "52px" }}
              >
                {rightButton?.title}
              </CustomButton>
            </S.ButtonsContainer>
          </Grid>
          <Grid item xs={12} md={6}>
            <S.ImageContainer>
              <S.Image img={image} />
              <S.NotificationWrapper>
                <S.NotificationContainer>
                  <S.Logo img={notificationInfo?.notificationLogo} />
                  <S.Title className="notification">
                    {notificationInfo?.title}
                  </S.Title>
                  <S.Time>{notificationInfo?.timeDescription}</S.Time>
                  <S.Description className="notification">
                    {notificationInfo?.text}
                  </S.Description>
                </S.NotificationContainer>
              </S.NotificationWrapper>
            </S.ImageContainer>
          </Grid>
        </Grid>
      </S.Wrapper>
      <DownloadAppDialog open={open} handleClose={handleClose} />
    </S.Section>
  )
}

export default OurMission
